import {
  ContentfulRichTextGatsbyReference,
  RenderRichTextData,
} from 'gatsby-source-contentful/rich-text';

export const generateSummaryText = (
  raw: RenderRichTextData<ContentfulRichTextGatsbyReference>,
  datePublished: string,
  readTimeString: string
) => {
  const averageWpm = 250;
  const wordCount = JSON.parse(raw).content.reduce((acc, item) => {
    if (item.nodeType !== 'paragraph') return acc;

    return acc + item.content[0].value.split(' ').length;
  }, 0);

  const date = new Date(datePublished);
  const dateTimeFormat = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  const minutes = Math.ceil(wordCount / averageWpm);
  return `${dateTimeFormat.format(date)} • ${minutes} ${readTimeString}`;
};
